import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';
import '../Newsletter/Newsletter.css';

const Newsletter = () => {
  const [formData, setFormData] = useState({ firstName: '', lastName: '', email: '' });
  const [errors, setErrors] = useState({ firstName: '', lastName: '', email: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = (name, value) => {
    let error = '';
    switch (name) {
      case 'firstName':
      case 'lastName':
        error = /^[A-Za-z]+$/.test(value) ? '' : 'Only alphabets are allowed';
        break;
      case 'email':
        error = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Invalid email address';
        break;
      default:
        break;
    }
    setErrors({ ...errors, [name]: error });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validate(name, value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!errors.firstName && !errors.lastName && !errors.email && formData.firstName && formData.lastName && formData.email) {
      setIsSubmitting(true);
      
      const emailData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        message: `${formData.firstName} ${formData.lastName} has subscribed to the newsletter.`
      };
      
      emailjs.send('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', emailData, 'YOUR_USER_ID')
        .then(() => {
          Swal.fire({ icon: 'success', title: 'Subscribed!', text: 'You have successfully subscribed to our newsletter.' });
          setFormData({ firstName: '', lastName: '', email: '' });
          setIsSubmitting(false);
        })
        .catch(() => {
          Swal.fire({ icon: 'error', title: 'Oops!', text: 'Something went wrong. Please try again later.' });
          setIsSubmitting(false);
        });
    }
  };

  return (
    <div className="newsletter">
      <h1>Subscribe to Our Newsletter</h1>
      <form className="newsletter-form" onSubmit={handleSubmit}>
        <div className="input-container">
          <input type="text" name="firstName" placeholder="First Name" className="input-field" value={formData.firstName} onChange={handleChange} />
          {errors.firstName && <span className="error">{errors.firstName}</span>}
        </div>

        <div className="input-container">
          <input type="text" name="lastName" placeholder="Last Name" className="input-field" value={formData.lastName} onChange={handleChange} />
          {errors.lastName && <span className="error">{errors.lastName}</span>}
        </div>

        <div className="input-container">
          <input type="email" name="email" placeholder="Email Address" className="input-field" value={formData.email} onChange={handleChange} />
          {errors.email && <span className="error">{errors.email}</span>}
        </div>

        <button type="submit" className="subscribe-btn" disabled={isSubmitting}>Subscribe</button>
      </form>
    </div>
  );
};

export default Newsletter;
